import { MantineProvider } from '@mantine/core'
import { QueryClientProvider } from '@tanstack/react-query'
import { PropsWithChildren } from 'react'
import queryClient from './queryClient'
import { useCreateTheme } from './theme'
import { ModalsProvider } from '@mantine/modals'
import { Notifications } from '@mantine/notifications'
import { useCustomizerStore } from 'store/customizerStore'
import { HelmetProvider } from 'components/common/Helmet'
import { getSystemColorScheme } from 'utils/getSystemColorScheme'
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

export const Providers = ({ children }: PropsWithChildren) => {
  const colorScheme = useCustomizerStore(state => state.colorScheme)
  const theme = useCreateTheme()
  const resolvedColorScheme =
    colorScheme === 'system' ? getSystemColorScheme() : colorScheme
  const isLight = resolvedColorScheme === 'light'

  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <MantineProvider
          theme={theme}
          forceColorScheme={resolvedColorScheme}
          cssVariablesResolver={() => ({
            variables: {
              '--cl-font-size': `${theme.other?.fontSize ?? 16}px`,
              '--cl-app-background': isLight ? '#f5f7fb' : '#17181a',
              '--cl-app-surface': isLight ? '#ffffff' : '#222329',
              '--cl-app-surface-subtle': isLight ? '#f9fafc' : '#292a30',
              '--cl-app-surface-elevated': isLight ? '#ffffff' : '#24252b',
              '--cl-app-border': isLight ? '#e2e7ef' : '#32333a',
              '--cl-app-border-strong': isLight ? '#d5dce8' : '#3e4048',
              '--cl-app-text-muted': isLight ? '#667085' : '#9ca3af',
              '--cl-app-shadow': isLight
                ? '0 14px 38px rgba(31, 41, 55, 0.08)'
                : '0 14px 36px rgba(0, 0, 0, 0.18)',
            },
            light: {},
            dark: {},
          })}
        >
          <ModalsProvider
            modalProps={{
              closeButtonProps: {
                'aria-label': 'Close modal',
              },
              styles: {
                overlay: {
                  zIndex: 1002,
                },
                inner: {
                  zIndex: 1003,
                },
              },
            }}
          >
            <Notifications />
            {children}
          </ModalsProvider>
        </MantineProvider>
        {/* <ReactQueryDevtools /> */}
      </QueryClientProvider>
    </HelmetProvider>
  )
}
